const twemoji = require('twemoji')
const qiniu = require('./qiniu')

function parse(content) {
  return twemoji.parse(content, iconId => `${qiniu.yoyoCommonServer}/emoji/${iconId}.png?v=1`)
}

module.exports = parse



// WEBPACK FOOTER //
// ./client/utils/emoji.js